const HubspotPropertiesEnum = Object.freeze({
    CONNECTED_AUTH_DATA: "api_verbindungen",
    MISSING_BOOKING_STACKS: "fehlende_buchungsstapel__kontensetup_",
    PAYMENT_TYPE: "zahlungsart_hinterlegt",
    ASSOCIATED_TAX_CONSULTANT: "steuerberater_account_hinterlegt_",
    VALID_DATEV_SETTINGS: "datev_einstellungen",
    TECHNICAL_EXPIRATION_DATE: "technical_expiration_date",
    ONBOARDING_STATUS: "onboarding_status",
    ACTIVE_BOOKING_STACKS: "buchungsstapel_erstellt",
    SHOPIFY_RECHNUNGSPRINTER_STATUS: "module_produkt",
    LAST_INVOICE_AMOUNT: "letzte_rechnungen",
    BOOKED_ADDITIONAL_FEATURES: "gebuchte_zusatzoptionen",
});

export default HubspotPropertiesEnum;
